export const ContactColumns = [
  // { key: 'sn', label: 'SN' },
  { key: 'action', label: 'Action' },
  // { key: 'status', label: 'Status' },
  { key: 'firstName', label: 'Name' },
  { key: 'office', label: 'Office' },
  { key: 'email', label: 'Email' },
  { key: 'phone', label: 'Phone' },
  { key: 'ext', label: 'Ext' },
  { key: 'cell', label: 'Cell' },
  { key: 'ectReport', label: 'ER' },
  { key: 'oilReport', label: 'OR' },
];
export const ContactMasterColumns = [
  // { key: 'sn', label: 'SN' },
  { key: 'action', label: 'Action' },
  // { key: 'status', label: 'Status' },
  { key: 'customerId', label: 'Customer Id' },
  { key: 'customerName', label: 'Customer' },
  { key: 'firstName', label: 'Name' },
  { key: 'office', label: 'Office' },
  { key: 'email', label: 'Email' },
  { key: 'phone', label: 'Phone' },
  { key: 'cell', label: 'Cell' },
];
